import React from "react";
import Header from "./common/Header";
import MainComponent from "./common/MainComponent";

export function VegArt() {
  return (
    <header className="fixed-top">
      <Header />
      <MainComponent />
    </header>
  );
}
export default VegArt;
